import { Box, Grid2 } from '@mui/material'
import { useEffect } from 'react'
import Heading from '../../shared/utils/Heading'
import { Page_Padding } from '../../shared/constants'
import FaqCard from '../../shared/components/FaqCard'
import { useGetContentDetail } from '../../assets/nodeApi/getApi/ContentGetApi'
import { usePageContentWithMeta } from '../../shared/hook/usePageContentWithMeta'

const Faq = ({ onLoadingChange }) => {

    const { data: FaqDetail, isLoading: isFaqLoading } =usePageContentWithMeta("FAQ");
   
    useEffect(() => {
        onLoadingChange(isFaqLoading);
    }, [isFaqLoading, onLoadingChange]);

    if (isFaqLoading) return null;


    return (
        <Box className="body contact_us" px={Page_Padding}>
            <Heading
                Heading={"Curious Minds: Get the Answers You’re Looking For!"}
                SubHeading={"Got questions? We’ve got the answers!"}
            />

            <Grid2 container spacing={5} sx={{ display: 'flex', justifyContent: "center" }}>

                {
                    FaqDetail?.content.slice(1, -1)?.map((item, index) => {

                        return (
                            <Grid2 hildren size={{ xs: 12, sm: 6, md: 4 }} key={index}
                                display={"flex"} alignItems={"stretch"}
                            >
                                <FaqCard index={index} item={item} />
                            </Grid2>
                        );
                    })
                }



            </Grid2>
        </Box>
    )
}

export default Faq